"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _UserView = _interopRequireDefault(require("../UserView"));

var s = _interopRequireWildcard(require("./styles"));

var getGridSize = function getGridSize(_ref) {
  var groups = _ref.groups;
  var totalItems = groups.map(function (group) {
    return group.items;
  }).flat().length;
  var size = 'medium';

  if (totalItems < 3) {
    size = 'mega';
  } else if (totalItems < 7) {
    size = 'large';
  } else if (totalItems > 12) {
    size = 'small';
  }

  return size;
};

var renderGroupItems = function renderGroupItems(items, props) {
  var size = props.size,
      viewType = props.viewType,
      onClick = props.onClick,
      showInviteLearner = props.showInviteLearner,
      isClassActive = props.isClassActive,
      onActionSelect = props.onActionSelect,
      isLearner = props.isLearner;
  return React.createElement("div", {
    className: (0, _classnames.default)(s.groupItemsWrapper, "".concat(viewType))
  }, items.map(function (item) {
    return React.createElement("div", {
      className: (0, _classnames.default)(s.userItemWrapper, "".concat(viewType)),
      key: item.id
    }, React.createElement(_UserView.default, (0, _extends2.default)({}, item, {
      size: size,
      viewType: viewType,
      showInviteLearner: showInviteLearner,
      onClick: onClick,
      isClassActive: isClassActive,
      onActionSelect: onActionSelect,
      isLearner: isLearner
    })));
  }));
};

var renderGroupGridView = function renderGroupGridView(props) {
  return function (group) {
    return React.createElement("div", {
      className: (0, _classnames.default)(s.groupContainer, "".concat(props.viewType))
    }, group.Header, renderGroupItems(group.items, props, group.onClick));
  };
};

function LiveClassLearners(props) {
  var groups = props.groups,
      rest = (0, _objectWithoutProperties2.default)(props, ["groups"]);
  var size = getGridSize(props);
  var childProps = (0, _objectSpread2.default)({}, rest, {
    size: size
  });
  return React.createElement("div", {
    className: s.gridWrapper
  }, groups.map(renderGroupGridView(childProps)));
}

LiveClassLearners.defaultProps = {
  groups: [],
  viewType: 'gridView',
  onClick: function onClick() {},
  showInviteLearner: false,
  isClassActive: false,
  isLearner: true
};
LiveClassLearners.propTypes = {
  groups: _propTypes.default.arrayOf(_propTypes.default.shape({
    Header: _propTypes.default.elementType,
    items: _propTypes.default.arrayOf(_propTypes.default.object)
  })),
  onClick: _propTypes.default.func,
  viewType: _propTypes.default.oneOf(['gridView', 'listView']),
  showInviteLearner: _propTypes.default.bool,
  isClassActive: _propTypes.default.bool,
  isLearner: _propTypes.default.bool
};
var _default = LiveClassLearners;
exports.default = _default;